export default __webpack_public_path__ + "static/image14-f1ebc939d7bbea42b21bbda7f9087fed.jpg";